/**
 * HomeENDemoInvoicePageContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeENDemoInvoicePageContent
 */

import { useHomeENDemoInvoicePageContentLogic } from '@/hooks/traits/useHomeENDemoInvoicePageContentLogic';
import type { HomeENDemoInvoicePageContentConfig } from '@/hooks/traits/useHomeENDemoInvoicePageContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeENDemoInvoicePageItem } from '@app/shared';
import { Split } from '@almadar/ui/components';
import { HomeENDemoInvoicePageListView } from '@/components/traits/HomeENDemoInvoicePageListView';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { HomeENDemoInvoicePageStatsView } from '@/components/traits/HomeENDemoInvoicePageStatsView';
import { HomeENDemoInvoicePageDetailView } from '@/components/traits/HomeENDemoInvoicePageDetailView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeENDemoInvoicePageContentViewProps {
  config?: Partial<HomeENDemoInvoicePageContentConfig>;
}

export function HomeENDemoInvoicePageContentView({ config: propsConfig }: HomeENDemoInvoicePageContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeENDemoInvoicePageContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeENDemoInvoicePageItem'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeEN" trait="HomeENDemoInvoicePageContent">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="sm" className="p-4"><Typography content={renderPatternValue(__t("std-almadar-demo-invoices-page:page.title"))} variant="h3" /><Split ratio="2:3" gap="md"><Stack direction="vertical" gap="sm"><HomeENDemoInvoicePageStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeENDemoInvoicePageListView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack><HomeENDemoInvoicePageDetailView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeENDemoInvoicePageContentView;
